import firedux from '../firedux'
import store, {dispatch} from '../store'

import {USERS_ENDPOINT} from '../../config/constants'

import setCurrentUser from '../actions/set_current_user'

export const watchCurrentUser = (uid) => {
  firedux.ref.child(`${USERS_ENDPOINT}/${uid}`).on('value', (snapshot) => {
    if (snapshot.val()) dispatch(setCurrentUser(snapshot.val()))
  })
}

export const unwatchCurrentUser = () => {
  const currentUser = store.getState().get('currentUser')

  if (currentUser && currentUser.get('uid')) {
    firedux.ref.child(`${USERS_ENDPOINT}/${currentUser.get('uid')}`).off()
    console.log('setting current user off')
    dispatch(setCurrentUser(null))
  }
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/watchers/current_user.js
 **/